__turbopack_context__.v({
  "bottom": "LivQRG_bottom",
  "brand": "LivQRG_brand",
  "columnHeading": "LivQRG_columnHeading",
  "columns": "LivQRG_columns",
  "footer": "LivQRG_footer",
  "legal": "LivQRG_legal",
  "links": "LivQRG_links",
  "main": "LivQRG_main",
});
